import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const DEFAULT_LINK_LABELS = {
  receipts_url: "Receipt.pdf",
  certificate_url: "Certificate.pdf",
  reports_url: "Reports.pdf",
};

function normalizeDocumentItems({ links = {}, items = [], linkLabels = {} }) {
  if (Array.isArray(items) && items.length > 0) {
    return items.filter((item) => item?.url);
  }

  const mergedLabels = {
    ...DEFAULT_LINK_LABELS,
    ...linkLabels,
  };

  return Object.entries(links)
    .filter(([, url]) => Boolean(url))
    .map(([key, url]) => ({
      key,
      url,
      label: mergedLabels[key] || key,
    }));
}

function DocumentLinksCard({
  title = "Generated Documents",
  links = {},
  items = [],
  linkLabels = {},
  emptyMessage = "No document links available yet. Submit the report first.",
  cardSx = {},
}) {
  const documentItems = normalizeDocumentItems({ links, items, linkLabels });

  return (
    <Grid item xs={12}>
      <Card variant="outlined" sx={{ mb: 2, ...cardSx }}>
        <CardHeader
          title={
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", textTransform: "uppercase" }}
            >
              {title}
            </Typography>
          }
          sx={{ px: 2, pt: 2, pb: 0 }}
        />

        <CardContent sx={{ px: 2, pb: 2 }}>
          <Grid container spacing={1}>
            {documentItems.length > 0 ? (
              documentItems.map((item) => (
                <Grid item xs={12} key={item.key || item.label || item.url}>
                  <Box>
                    <Link
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textDecoration: "none",
                        color: "primary.main",
                        display: "inline-flex",
                        alignItems: "center",
                        wordBreak: "break-word",
                      }}
                    >
                      {item.label}
                      <OpenInNewIcon sx={{ ml: 1, fontSize: "1rem", flexShrink: 0 }} />
                    </Link>
                  </Box>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography variant="body1" color="text.secondary">
                  {emptyMessage}
                </Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default DocumentLinksCard;